import React, { Fragment, useState } from 'react';
import Button from '../../../Button';
import Modal from '../../../common/Modal';
import Form from './form';
import { ToastContainer } from 'react-toastify';
import styles from "./WorkOrder.module.sass";

const WorkOrder = ({ workOrderTypes, detailFields = {}, modelName = undefined, modelId = undefined, modelType = undefined, isLink = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <Fragment>
      {!isLink && (
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      )}

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel={`Create Work Order ${modelName && `for ${modelName}`}`}
        headerText={`Create Work Order ${modelName && `for ${modelName}`}`}
      >
        <Form closeModal={closeModal} workOrderTypes={workOrderTypes} detailFields={detailFields} modelType={modelType} modelId={modelId} />
      </Modal>

      {isLink ? <a onClick={openModal} className={styles.link}>Create WO</a> : <Button onClick={openModal}>Create Work Order</Button>}
    </Fragment>
  )
}

export default WorkOrder;
